interface ScriptConfig {
    /**
     * The full path to the script to load
     */
    src: string;

    /**
     * An id that will be passed to the script's "id" attribute
     */
    scriptId: string;

    /**
     * An optional document node to insert the script to. Defaults to `document.head`
     */
    documentNode?: HTMLElement;
}

/**
 * Loads an external scripts and inserts it into the DOM
 *
 * @param config
 */
export const loadScript = (config: ScriptConfig): Promise<void> => {
    return new Promise(resolve => {
        const existingScript = document.getElementById(config.scriptId);

        if (existingScript) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.src = config.src;
        script.id = config.scriptId;
        script.onload = () => {
            resolve();
        };

        const node = config.documentNode ?? document.head;

        if (node) {
            node.appendChild(script);
        }
    });
};
